// extracted by mini-css-extract-plugin
module.exports = {"title":"subcategory_title__vkf1U","titleIcon":"subcategory_titleIcon__1OgCO"};